import request from "Apis/BaseRequest";
import { BaseApiService } from "Apis/Service/BaseApiService";
import { ITaskController } from "Interfaces/Controllers/ITaskController";
import { IEnvConfigUtils } from "Interfaces/Utils/IEnvConfigUtils";
import { inject, injectable } from "inversify";
import moment from "moment-timezone";
import Types from "ServiceProvider/Types";

@injectable()
export class TaskController extends BaseApiService implements ITaskController {
    constructor(@inject(Types.IEnvConfigUtils) envConfigUtils: IEnvConfigUtils) {
        super(envConfigUtils, "generatedtasks");
    }

    public async export(fromDate: Date, toDate: Date): Promise<string> {
        this.init();

        const response = await request
            .get(`${this.endpoint}/export`)
            .query({ 
                from: moment(fromDate).format("YYYY-MM-DD"), 
                to: moment(toDate).format("YYYY-MM-DD"),
                timezone: moment.tz.guess()
            })
            .set(this.headers);

        return response.text;
    }
}


// WEBPACK FOOTER //
// ./src/Apis/Controllers/TaskController.ts